// extracted by mini-css-extract-plugin
export default {"ProgramGroupMessage":"ProgramGroupMessage-module-d1838187b66ee0de6f2a"};